import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { PropsWithChildren } from 'react';
import { Style } from 'util';
import CSS from 'csstype';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 200px)',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
  maxHeight: 'calc(100% - 200px)'
};

export interface BasicModalExpandedProps extends PropsWithChildren<any> {
  open: boolean;
  handleClose: () => void;
  style: CSS.Properties;
}

export default function BasicModalExpanded(props: BasicModalExpandedProps) {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} style={props.style}>
        {props.children}
      </Box>
    </Modal>
  );
}
